import(/* webpackMode: "eager" */ "/Users/r.wichmann/workspace/_private/robinwichmann.com/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["WorkCaseDetailClient"] */ "/Users/r.wichmann/workspace/_private/robinwichmann.com/src/components/work/WorkCaseDetailClient.tsx");
